import React, { useState } from "react";
import FieldItem from "../FieldItem";
import "./index.scss";
import { Droppable, Draggable } from "react-beautiful-dnd";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import { Icon } from "shared";
import t from "utils/Lang";

type GroupItemProps = {
  group: any;
  onCreateField: () => void;
  onEditGroup: () => void;
  onDeleteGroup: () => void;
  onDuplicate: () => void;
  onSelectField: (id: number) => void;
};

const GroupItem = ({
  group,
  onCreateField,
  onEditGroup,
  onDeleteGroup,
  onSelectField,
  onDuplicate,
}: GroupItemProps) => {
  const [openMenu, setOpenMenu] = useState(false);
  const toggleMenu = () => setOpenMenu(!openMenu);
  const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
    userSelect: "none",
    // change background colour if dragging
    // background: isDragging ? 'var(--color-highlight-action)' : 'none',
    ...draggableStyle,
  });
  const renderField = (field: any, index: number) => {
    return (
      <Draggable key={field.id} draggableId={`${field.id}`} index={index}>
        {(dragProvided, dragSnapshot) => {
          return (
            <div
              ref={dragProvided.innerRef}
              {...dragProvided.draggableProps}
              {...dragProvided.dragHandleProps}
              style={getItemStyle(
                dragSnapshot.isDragging,
                dragProvided.draggableProps.style
              )}
            >
              <FieldItem
                field={field}
                key={field.id}
                onSelectField={onSelectField}
              />
            </div>
          );
        }}
      </Draggable>
    );
  };
  return (
    <div className="group-item__container">
      <div className="group-header">
        <span
          className="group-name"
          style={{ opacity: group.is_show ? 1 : 0.5 }}
        >
          {group.name}
        </span>
        <Dropdown isOpen={openMenu} toggle={toggleMenu}>
          <DropdownToggle className="more-button">
            <Icon name="more_horiz" size="medium" fill={false} />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem onClick={onDuplicate}>Duplicate</DropdownItem>
            <DropdownItem onClick={onEditGroup}>
              {t().action__edit}
            </DropdownItem>
            <DropdownItem onClick={onDeleteGroup}>
              {t().action__delete}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div className="group-body__wrapper">
        <Droppable
          droppableId={`${group.id}`}
          direction="vertical"
          type="field"
        >
          {(provided, snapshot) => {
            return (
              <div
                className="group-body"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                <div style={{ height: 0.1 }} />
                {group.fields.map(renderField)}
                {provided.placeholder}
              </div>
            );
          }}
        </Droppable>
      </div>
      <div className="group-footer">
        <div className="add-field-button" onClick={onCreateField}>
          <i className="material-icons">add</i>
          <div style={{ width: 10 }} />
          <span>Add Field</span>
        </div>
      </div>
    </div>
  );
};

export default GroupItem;
